import DashboardIcon from "../../../assets/images/menu-icons/dashboard-icon.svg";
import LocationIcon from "../../../assets/images/menu-icons/location-icon.svg";
import ProductIcon from "../../../assets/images/menu-icons/product-icon.svg";
import BrandIcon from "../../../assets/images/menu-icons/brand-icon.svg";
import SellerIcon from "../../../assets/images/menu-icons/seller-icon.svg";
import LogoutIcon from "../../../assets/images/menu-icons/logout-icon.svg";
import ContactUsIcon from "../../../assets/images/menu-icons/contact-icon.svg";
import TagsIcon from "../../../assets/images/menu-icons/tag-icon.svg";
import RewardsIcon from "../../../assets/images/menu-icons/rewards.png";

export const MenuItemsData = [
  {
    path: `/dashboard`,
    icon: DashboardIcon,
    title: "Dashboard",
  },

  {
    title: "Locations",
    icon: LocationIcon,
    path: `/location-list`,
  },
  {
    title: "Products",
    icon: ProductIcon,
    path: `/product-list`,
  },
  {
    title: "Brands",
    icon: BrandIcon,
    path: `/brands/brands-list`,
  },

  {
    title: "Seller",
    icon: SellerIcon,
    path: `/seller/seller-list`,
  },
  {
    title: "Rewards",
    icon: RewardsIcon,
    path: `/rewards`,
  },
  {
    title: "Tags",
    icon: TagsIcon,
    path: `/tags/tags-list`,
  },
];

export const ProfileMenuItems = [
  {
    title: "Contact Us",
    icon: ContactUsIcon,
    id: "contact-us",
  },
  {
    title: "Log out",
    id: "log-out",
    icon: LogoutIcon,
  },
];
